<script lang="ts">
  import { gallery } from '../gallery/api';
  import { t } from '../i18n/index.svelte';

  let {
    open = $bindable(),
    prepare,
    params,
  }: {
    open: boolean;
    /** Produces the file to publish (and an optional preview image). */
    prepare: () => Promise<{ file: Blob; name: string; preview?: Blob }>;
    /** Settings that can be shared (never includes the source photo). */
    params: unknown;
  } = $props();

  let title = $state('');
  let caption = $state('');
  let withParams = $state(false);
  let busy = $state(false);
  let done = $state(false);
  let error = $state('');

  async function send() {
    busy = true;
    error = '';
    try {
      const { file, name, preview } = await prepare();
      const f = new FormData();
      f.set('file', file, name);
      if (preview) f.set('preview', preview, 'preview.jpg');
      f.set('title', title);
      f.set('caption', caption);
      if (withParams) {
        f.set('params_consent', 'true');
        f.set('params', JSON.stringify(params));
      }
      await gallery.submit(f);
      done = true;
    } catch (e) {
      error = e instanceof Error ? e.message : String(e);
    } finally {
      busy = false;
    }
  }

  function close() {
    open = false;
    done = false;
    error = '';
  }
</script>

{#if open}
  <div class="backdrop" role="presentation" onclick={(e) => e.target === e.currentTarget && close()}>
    <div class="dialog" role="dialog" aria-modal="true" aria-labelledby="pub-title" data-testid="publish-dialog">
      <h3 id="pub-title">{t('publish.title')}</h3>
      {#if done}
        <p data-testid="publish-done">{t('publish.done')}</p>
        <div class="row end"><button class="primary" onclick={close}>{t('common.close')}</button></div>
      {:else}
        <label class="field"
          ><span>{t('publish.name')}</span><input
            type="text"
            maxlength="120"
            bind:value={title}
            data-testid="publish-name"
          /></label
        >
        <label class="field"
          ><span>{t('publish.caption')}</span><textarea rows="3" maxlength="1000" bind:value={caption}
          ></textarea></label
        >
        <label class="check"
          ><input type="checkbox" bind:checked={withParams} data-testid="publish-params" />
          <span>{t('publish.withParams')}</span></label
        >
        <p class="muted small">{t('publish.moderation')}</p>
        {#if error}<p class="error small">{error}</p>{/if}
        <div class="row end">
          <button onclick={close}>{t('common.cancel')}</button>
          <button class="primary" disabled={busy} onclick={send} data-testid="publish-send"
            >{busy ? t('publish.sending') : t('publish.send')}</button
          >
        </div>
      {/if}
    </div>
  </div>
{/if}

<style>
  .backdrop {
    position: fixed;
    inset: 0;
    background: #000a;
    display: grid;
    place-items: center;
    z-index: 50;
    padding: 16px;
  }
  .dialog {
    background: var(--panel);
    border: 1px solid var(--line);
    border-radius: 12px;
    padding: 20px;
    width: min(440px, 100%);
    display: flex;
    flex-direction: column;
    gap: 12px;
    box-shadow: 0 20px 60px #000c;
  }
  h3 {
    margin: 0;
  }
  .field {
    display: flex;
    flex-direction: column;
    gap: 4px;
    font-size: 13px;
  }
  .check {
    display: flex;
    gap: 8px;
    align-items: flex-start;
    font-size: 13px;
  }
  .end {
    justify-content: flex-end;
  }
  .small {
    font-size: 12px;
    margin: 0;
  }
</style>
